export default "__VITE_ASSET__Btt9x0ip__"